<template>
  <section class="layer-section sku-laser">
    <a class="section-title" href="https://topic.vivo.com.cn/activity/link/leidiao">镭雕镌刻（可选）</a>
    <div class="section-content lettering">
      <div class="btn-wrapper">
        <div class="section-btn" @click="toggleLaser" :class="{ checked: checked }">
          <p class="name">镭雕定制服务</p>
        </div>
      </div>
      <p class="tip" v-if="checked">
        <dfn>*</dfn>
        定制的商品如非质量问题，不支持退货和换货
      </p>
    </div>
  </section>
</template>

<script>
export default {
  name: 'sku-laser',
  props: {
    checked: Boolean
  },
  methods: {
    toggleLaser() {
      this.$emit('laserChange', !this.checked)
    }
  }
}
</script>
